import {components} from "react-select";
import React from "react";


export const CustomCollapsedOption = (props) => {
    const isCollapsed = props.selectProps.isCollapsed;
    const {collapsedLabel, label} = props.data;

    const renderOption = () => {
        if (isCollapsed) {
            return collapsedLabel ?? label;
        }
        return label;
    }

    return (
        <components.Option {...props}>
            {renderOption()}
        </components.Option>
    );
};